export const SOFTLINE_SETTINGS_INTEGRATED_SCANNER = 'integratedScanner';
